import { ReactNode, SyntheticEvent } from "react"

interface Props {
    competences: ReactNode
}

export function MoreCompetencesList({ competences }: Props) {
    function buttonClickHandler(e: SyntheticEvent<HTMLButtonElement>) {
        e.preventDefault()
        const neighbourElement = e.currentTarget.previousElementSibling
        if (!neighbourElement) return
        neighbourElement.classList.toggle("details__list-item--more-list-show")
        if (neighbourElement.classList.contains("details__list-item--more-list-show")) {
            e.currentTarget.innerText = "Свернуть"
        } else {
            e.currentTarget.innerText = "Еще"
        }
    }

    return (
        <li className="details__list-item details__list-item--more">
            <ul className="details__list-item--more-list">{competences}</ul>
            <button className="details__list-item--more-button" onClick={buttonClickHandler}>
                Еще
            </button>
        </li>
    )
}
